import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Item from './Item';
import { formName } from 'data/formNames';
import { formValueSelector } from 'redux-form';

class LiftAndCranesList extends React.Component {
    render() {
        const items = [];
        const { liftsCranes } = this.props;

        for (const key in liftsCranes) {
            items.push(liftsCranes[key]);
        }

        return (
            <Fragment>
                <div className='main__title'>
                    Available Lift and Cranes
                </div>

                <div className='lift-and-cranes'>
                    {
                        items.map((liftCrane, key) => (
                            <Item
                                key={key}
                                liftCrane={liftCrane}
                                liftsCranes={liftsCranes}
                            />
                        ))
                    }
                </div>
            </Fragment>


        );
    }
}

LiftAndCranesList.propTypes = {

};

LiftAndCranesList.defaultProps = {

};

const selector = formValueSelector(formName.portCreate);
export default connect(
    state => ({
        liftsCranes: selector(state, 'liftsCranes'),
    }),
    dispatch => bindActionCreators({

    }, dispatch),
)(LiftAndCranesList);



// WEBPACK FOOTER //
// ./app/components/Regions/PortAdd/LiftAndCranes/List.jsx